import {formatDate} from './utils/formatDate';
import {debounce} from './utils/debounce';
import {formatMoney} from './utils/formatMoney';
import {isWithinLast8Hours} from './utils/datetime-helpers';
import {getValidationErrorMessages} from './utils/validationErrors';
import {GcCertifyActions, NotificationType, PermissionLevelEnum} from './enums';
import * as Roles from './AccessControl';
import * as Contracts from './api/ContractsApi';
import * as Vendors from './api/VendorApi';
import * as Bids from './api/BidApi';
import * as ErrorsModule from './errors';

// Export all types and interfaces
export * from './types';

// Export API classes
export * from './api/ApplicationApi'
export * from './api/AccountApi';
export * from './api/AdminAccount';
export * from './api/BidApi';
export * from './api/ContractsApi';
export * from './api/RoleApi';
export * from './api/VendorApi';

const Utils = {
  formatDate,
  debounce,
  getValidationErrorMessages,
  formatMoney,
  isWithinLast8Hours
};

const Enums = {
  NotificationType,
  GcCertifyActions,
  PermissionLevelEnum
}

const Authorization = {
  Roles
};

const API = {
  Contracts,
  Vendors,
  Bids
}

// Export all error types and utilities
const Errors = {
  ...ErrorsModule
};

export {
  Utils,
  Enums,
  Authorization,
  API,
  Errors
}
